import { Landing, LandingPage } from ".";
export default {
  path: "",
  childRoutes: [
    { path: "/home", component: Landing, isIndex: false },
    { path: "", component: LandingPage, isIndex: true },
],
};
